export const createCompanySlice = (set, get) => ({
  companyProfile: {
    website_url: "",
    description: "",
    services: [],
    company_services: [], // For suggestions only, not sent to API
  },

  setCompanyProfile: (updates) =>
    set((state) => ({
      companyProfile: {
        ...state.companyProfile,
        ...updates,
      },
    })),

  getCompanySubmitData: () => {
    const { companyProfile } = get();
    
    // Return only the required format for API
    return {
      websiteUrl: companyProfile.website_url || "",
      summary: companyProfile.description || "",
      companyServices: companyProfile.services || [],
    };
  },
});
